// extracted by mini-css-extract-plugin
export default {"itemTitle":"BillingItem_itemTitle__4Nkp0","itemDivider":"BillingItem_itemDivider__3+ll6","itemHeader":"BillingItem_itemHeader__7FWJL"};